import { StyledCard, StyledCardTitle } from '../pages/Review.styled';

export const CheckInPolicy = () => (
  <StyledCard>
    <StyledCardTitle>Thủ tục nhận phòng</StyledCardTitle>
    <p>
      - Anh chị vui lòng mang 2 CCCD trên 18 tuổi để nhận phòng
      <br />- Vui lòng tải thông tin đặt phòng về máy để nhận phòng được nhanh hơn
    </p>
  </StyledCard>
);

export const CancelPolicy = () => (
  <StyledCard>
    <StyledCardTitle>Chính sách huỷ phòng</StyledCardTitle>
    <p>
      - Nếu quý khách có thay đổi ngày giờ đặt phòng vui lòng nhắn tin hoặc gọi điện báo Đào Tiên <br />
      - Đặt phòng của quý khách sẽ tự động huỷ quá 20 phút sau giờ đặt. <br />
      - Đặt phòng theo giờ: Huỷ miễn phí trước giờ nhận phòng 1 tiếng. <br />
      - Đặt phòng qua đêm: Huỷ miễn phí trước giờ nhận phòng 2 tiếng. <br />
      - Đặt phòng theo ngày: Huỷ miễn phí trước giờ nhận phòng 12 tiếng. <br />
    </p>
  </StyledCard>
);
